import { render, staticRenderFns } from "./DashboardCards.vue?vue&type=template&id=99234de4"
import script from "./DashboardCards.vue?vue&type=script&lang=js"
export * from "./DashboardCards.vue?vue&type=script&lang=js"
import style0 from "./DashboardCards.vue?vue&type=style&index=0&id=99234de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports